<div class="link-list"></div>
<button class="button add-link-button input-block-level neutral">
	<i class="icon-plus"></i>&nbsp;<span data-i18n="editor.inspector.properties.embeddedLinks.add"></span>
</button>